import * as React from "react";
import { SVGProps } from "react";
export function MemberTypeGraduateDetailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={15}
      height={14}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#member-type-graduate-detail_svg__a)"
        stroke="#886D00"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.5 1.367 14 4.184 7.5 7 1 4.184l6.5-2.817Z" />
        <path d="m3.953 5.469.007 3.064s1.073 1.42 3.544 1.42c2.47 0 3.55-1.42 3.55-1.42l-.001-3.064M2.195 10.601v-5.89M2.196 12.993a1.196 1.196 0 1 0 0-2.392 1.196 1.196 0 0 0 0 2.392Z" />
      </g>
      <defs>
        <clipPath id="member-type-graduate-detail_svg__a">
          <path fill="#fff" transform="translate(.5)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
